module.exports = function(a, b) {
  if (!a && b) return b;
  else if (!b && a) return a;
  else if (!a && !b) return 0;
  return a + b;
};
